module.exports = __webpack_public_path__ + "img/epr-price@2x.a82ed01c.webp";